import { render } from "./Minus.vue?vue&type=template&id=6ce46f5c"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Minus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ce46f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ce46f5c', __exports__)) {
    api.reload('6ce46f5c', __exports__)
  }
  
  module.hot.accept("./Minus.vue?vue&type=template&id=6ce46f5c", () => {
    api.rerender('6ce46f5c', render)
  })

}


export default __exports__